"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-standard-projects-container" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[0] || (_cache[0] = [
                (0, vue_1.createTextVNode)("Standard Projects", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getBasicStandardProjects(), (card) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: "cardbox",
                key: card
            }, [
                (0, vue_1.createVNode)(_component_Card, {
                    card: { 'name': card }
                }, null, 8, ["card"])
            ]));
        }), 128)),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[1] || (_cache[1] = [
                (0, vue_1.createTextVNode)("Standard Projects from Expansions and Solo Mode", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getExpansionStandardProjects(), (card) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: "cardbox",
                key: card
            }, [
                (0, vue_1.createVNode)(_component_Card, {
                    card: { 'name': card }
                }, null, 8, ["card"])
            ]));
        }), 128)),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[2] || (_cache[2] = [
                (0, vue_1.createTextVNode)("Standard Project from Fan-made Expansions", -1)
            ]))])), [
            [_directive_i18n]
        ]),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getFanMadeStandardProjects(), (card) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: "cardbox",
                key: card
            }, [
                (0, vue_1.createVNode)(_component_Card, {
                    card: { 'name': card }
                }, null, 8, ["card"])
            ]));
        }), 128))
    ]));
}
